/**
 * Coffee Quiz – state, navigation, progress, animations.
 * Supports optional conditional questions (e.g. capsule system after "capsules").
 */
(function () {
  const STORAGE_KEY = 'coffee_quiz_state';
  const MAX_QUESTIONS = 6;

  function initSection(sectionId) {
    const root = document.getElementById('CoffeeQuiz-' + sectionId) || document.querySelector('.coffee-quiz[data-section-id="' + sectionId + '"]');
    if (!root || root.dataset.cqInitialized === 'true') return;
    root.dataset.cqInitialized = 'true';

    const dataTestUrl = root.dataset.testProductUrl || '';
    const dataAllProductsUrl = root.dataset.allProductsUrl || '/collections/all';
    const enableAnimations = root.dataset.enableAnimations === 'true';

    const questionsEl = root.querySelector('[data-cq-questions]');
    const resultsEl = root.querySelector('[data-cq-results]');
    const progressLabel = root.querySelector('[data-cq-progress-label]');
    const progressPercent = root.querySelector('[data-cq-progress-percent]');
    const progressFill = root.querySelector('[data-cq-progress-fill]');
    const progressBar = root.querySelector('.cq-progress__bar');
    const navBackWrap = root.querySelector('[data-cq-nav-back]');

    const questionNodes = Array.from(root.querySelectorAll('[data-cq-question]')).slice(0, MAX_QUESTIONS);

    let state = {
      currentStep: 0,
      answers: {},
      showResults: false,
      resultQuestionIndex: null
    };

    function shouldShowQuestion(index) {
      const node = questionNodes[index];
      if (!node) return false;
      if (node.dataset.cqConditional !== 'true') return true;
      const required = (node.dataset.cqShowWhen || '').trim();
      if (!required) return false;
      const prev = state.answers[index - 1];
      return !!(prev && String(prev.value) === required);
    }

    function getActiveSteps() {
      const steps = [];
      for (let i = 0; i < questionNodes.length; i++) {
        if (shouldShowQuestion(i)) steps.push(i);
      }
      return steps;
    }

    function getNextStep(fromIndex) {
      const active = getActiveSteps();
      const pos = active.indexOf(fromIndex);
      if (pos === -1) {
        for (let i = 0; i < active.length; i++) {
          if (active[i] > fromIndex) return active[i];
        }
        return null;
      }
      if (pos < active.length - 1) return active[pos + 1];
      return null;
    }

    function getPrevStep(fromIndex) {
      const active = getActiveSteps();
      const pos = active.indexOf(fromIndex);
      if (pos > 0) return active[pos - 1];
      if (pos === -1) {
        for (let i = active.length - 1; i >= 0; i--) {
          if (active[i] < fromIndex) return active[i];
        }
      }
      return null;
    }

    function clearAnswersAfter(questionIndex) {
      Object.keys(state.answers).forEach(function (key) {
        if (parseInt(key, 10) > questionIndex) delete state.answers[key];
      });
    }

    function persist() {
      try {
        const payload = {
          currentStep: state.currentStep,
          showResults: state.showResults,
          resultQuestionIndex: state.resultQuestionIndex,
          answers: Object.keys(state.answers).map(function (k) {
            const entry = state.answers[k];
            return {
              step: parseInt(k, 10),
              value: entry.value,
              destinationUrl: entry.destinationUrl,
              optionIndex: entry.optionIndex
            };
          })
        };
        sessionStorage.setItem(STORAGE_KEY + '_' + sectionId, JSON.stringify(payload));
      } catch (e) {}
    }

    function loadPersisted() {
      try {
        const raw = sessionStorage.getItem(STORAGE_KEY + '_' + sectionId);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed.currentStep !== 'number') return;

        state.answers = {};
        (parsed.answers || []).forEach(function (entry) {
          if (entry && typeof entry.step === 'number' && entry.value != null) {
            state.answers[entry.step] = {
              value: entry.value,
              destinationUrl: entry.destinationUrl,
              optionIndex: entry.optionIndex
            };
          }
        });

        const active = getActiveSteps();
        if (!active.length) {
          state.currentStep = 0;
          state.showResults = false;
          return;
        }

        if (parsed.showResults === true) {
          state.showResults = true;
          state.resultQuestionIndex =
            typeof parsed.resultQuestionIndex === 'number'
              ? parsed.resultQuestionIndex
              : active[active.length - 1];
          state.currentStep = state.resultQuestionIndex;
        } else {
          state.showResults = false;
          state.resultQuestionIndex = null;
          if (active.indexOf(parsed.currentStep) !== -1) {
            state.currentStep = parsed.currentStep;
          } else {
            state.currentStep = active[0];
          }
        }
      } catch (e) {}
    }

    loadPersisted();

    function getProgress() {
      if (state.showResults) return 100;
      const active = getActiveSteps();
      if (!active.length) return 0;
      const pos = active.indexOf(state.currentStep);
      const stepPos = pos === -1 ? 0 : pos;
      return Math.round((stepPos / active.length) * 100);
    }

    function updateProgressUI() {
      const active = getActiveSteps();
      const pct = getProgress();
      const pos = active.indexOf(state.currentStep);
      const displayPos = state.showResults ? active.length : (pos === -1 ? 1 : pos + 1);
      const displayTotal = Math.max(active.length, 1);

      if (progressLabel) {
        progressLabel.textContent = state.showResults
          ? 'Резултат'
          : 'Въпрос ' + displayPos + ' от ' + displayTotal;
      }
      if (progressPercent) progressPercent.textContent = pct + '%';
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressBar) progressBar.setAttribute('aria-valuenow', pct);
      if (navBackWrap) {
        if (state.showResults || state.currentStep <= 0 || getPrevStep(state.currentStep) === null) {
          navBackWrap.setAttribute('hidden', '');
        } else {
          navBackWrap.removeAttribute('hidden');
        }
      }
    }

    function showQuestion(index, withAnimation) {
      questionNodes.forEach(function (node, i) {
        const isActive = i === index;
        node.classList.remove('cq-question--active', 'cq-question--enter', 'cq-question--leave');
        if (withAnimation && enableAnimations) {
          if (isActive) node.classList.add('cq-question--active', 'cq-question--enter');
        } else if (isActive) {
          node.classList.add('cq-question--active');
        }
      });
      if (navBackWrap) {
        if (getPrevStep(index) === null) {
          navBackWrap.setAttribute('hidden', '');
        } else {
          navBackWrap.removeAttribute('hidden');
        }
      }
    }

    function showResultCard(questionIndex, optionIndex) {
      const groups = root.querySelectorAll('[data-cq-results-group]');
      let activeGroup = null;

      groups.forEach(function (group) {
        const idx = parseInt(group.getAttribute('data-question-index'), 10);
        if (idx === questionIndex) {
          group.removeAttribute('hidden');
          activeGroup = group;
        } else {
          group.setAttribute('hidden', '');
        }
      });

      const cards = activeGroup
        ? activeGroup.querySelectorAll('.cq-result-card--option')
        : root.querySelectorAll('.cq-result-card--option');

      cards.forEach(function (card) {
        const idx = parseInt(card.getAttribute('data-cq-result-option-index'), 10);
        if (idx === optionIndex) {
          card.classList.add('cq-result-card--visible');
        } else {
          card.classList.remove('cq-result-card--visible');
        }
      });
    }

    function resolveResultAnswer(optionIndex) {
      let questionIndex =
        typeof state.resultQuestionIndex === 'number'
          ? state.resultQuestionIndex
          : null;

      if (questionIndex === null) {
        const active = getActiveSteps();
        questionIndex = active.length ? active[active.length - 1] : 0;
      }

      const answer = state.answers[questionIndex];
      const idx =
        typeof optionIndex === 'number'
          ? optionIndex
          : answer && typeof answer.optionIndex === 'number'
            ? answer.optionIndex
            : 0;

      return { questionIndex: questionIndex, optionIndex: idx };
    }

    function showResultsScreen(optionIndex) {
      questionNodes.forEach(function (node) {
        node.classList.remove('cq-question--active');
      });
      if (questionsEl) questionsEl.classList.add('cq-questions--hidden');
      if (resultsEl) resultsEl.removeAttribute('hidden');
      if (navBackWrap) navBackWrap.setAttribute('hidden', '');
      const resolved = resolveResultAnswer(optionIndex);
      showResultCard(resolved.questionIndex, resolved.optionIndex);
    }

    function hideResultsScreen() {
      if (resultsEl) resultsEl.setAttribute('hidden', '');
      root.querySelectorAll('[data-cq-results-group]').forEach(function (group) {
        group.setAttribute('hidden', '');
      });
      root.querySelectorAll('.cq-result-card--option').forEach(function (card) {
        card.classList.remove('cq-result-card--visible');
      });
    }

    function goToStep(index) {
      state.currentStep = index;
      state.showResults = false;
      state.resultQuestionIndex = null;
      hideResultsScreen();
      if (questionsEl) questionsEl.classList.remove('cq-questions--hidden');
      showQuestion(index, true);
      updateProgressUI();
      persist();
    }

    function selectOption(questionIndex, optionIndex, value, destinationUrl) {
      state.answers[questionIndex] = {
        value: value,
        destinationUrl: destinationUrl || dataTestUrl,
        optionIndex: optionIndex
      };
      clearAnswersAfter(questionIndex);
      persist();

      const next = getNextStep(questionIndex);
      if (next !== null) {
        state.currentStep = next;
        state.showResults = false;
        state.resultQuestionIndex = null;
        showQuestion(state.currentStep, true);
        updateProgressUI();
        persist();
      } else {
        state.showResults = true;
        state.resultQuestionIndex = questionIndex;
        state.currentStep = questionIndex;
        showResultsScreen(optionIndex);
        updateProgressUI();
        persist();
      }
    }

    function restart() {
      state = {
        currentStep: 0,
        answers: {},
        showResults: false,
        resultQuestionIndex: null
      };
      persist();
      hideResultsScreen();
      if (questionsEl) questionsEl.classList.remove('cq-questions--hidden');
      showQuestion(0, false);
      updateProgressUI();
      root.querySelectorAll('[data-cq-option]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', 'false');
        btn.classList.remove('cq-option--selected');
      });
    }

    if (questionsEl) {
      questionsEl.addEventListener('click', function (e) {
        const option = e.target.closest('[data-cq-option]');
        if (!option) return;
        const question = option.closest('[data-cq-question]');
        if (!question) return;
        const questionIndex = parseInt(question.dataset.questionIndex, 10);
        if (isNaN(questionIndex) || questionIndex !== state.currentStep) return;

        const optionIndex = parseInt(option.dataset.optionIndex, 10);
        const value = option.dataset.value || '';
        const destinationUrl = (option.dataset.destinationUrl || '').trim() || dataTestUrl;

        question.querySelectorAll('[data-cq-option]').forEach(function (btn) {
          btn.setAttribute('aria-pressed', 'false');
          btn.classList.remove('cq-option--selected');
        });
        option.setAttribute('aria-pressed', 'true');
        option.classList.add('cq-option--selected');

        selectOption(questionIndex, optionIndex, value, destinationUrl);
      });
    }

    root.querySelectorAll('[data-cq-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const prev = getPrevStep(state.currentStep);
        if (prev === null) return;
        goToStep(prev);
      });
    });

    root.querySelectorAll('[data-cq-restart]').forEach(function (btn) {
      btn.addEventListener('click', restart);
    });

    var allProductsLink = root.querySelector('[data-cq-all-products]');
    if (allProductsLink) allProductsLink.href = dataAllProductsUrl;

    updateProgressUI();
    if (state.showResults) {
      showResultsScreen();
    } else {
      showQuestion(state.currentStep, false);
    }

    root.querySelectorAll('[data-cq-option]').forEach(function (btn) {
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-pressed', 'false');
    });
  }

  function init() {
    document.querySelectorAll('.coffee-quiz').forEach(function (root) {
      var sectionId = root.dataset.sectionId || (root.id && root.id.replace(/^CoffeeQuiz-/, ''));
      if (sectionId) initSection(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.detail.sectionId;
    var root = document.getElementById('CoffeeQuiz-' + section);
    if (root) {
      root.dataset.cqInitialized = 'false';
      initSection(section);
    }
  });
})();
